module.exports = __webpack_public_path__ + "static/media/oil-temp.43904ea7.svg";